export default function formatPhoneNumber(phoneNumber: string): string {
    const cleanNumber = phoneNumber.replace(/[^\d]/g, '');

    const area = cleanNumber.substring(0, 3);
    const part1 = cleanNumber.substring(3, 6);
    const part2 = cleanNumber.substring(6, 10);

    let formattedNumber = '';

    if (part2) {
        formattedNumber = `(${area}) ${part1}-${part2}`;
    } else if (part1) {
        formattedNumber = `(${area}) ${part1}`;
    } else if (area) {
        formattedNumber = `(${area}`;
    }

    return formattedNumber;
}
